const AI_HIGHLIGHT_STYLES = {
  defaultBlue: {
    value: 'defaultBlue',
    style: {
      color: '#1890FF',
    },
  },
  probable: {
    value: 'probable',
    style: {
      color: '#FF9F00',
    },
  },
  exact: {
    value: 'exact',
    style: {
      backgroundColor: '#00FF0080',
    },
  },
  near: {
    value: 'near',
    style: {
      backgroundColor: '#00FFFFCC',
    },
  },
  synonym_level_0: {
    value: 'synonym_level_0',
    style: {
      backgroundColor: '#C300FF33',
    },
  },
  synonym_level_1: {
    value: 'synonym_level_1',
    style: {
      backgroundColor: '#C300FF33',
    },
  },
  synonym_level_2: {
    value: 'synonym_level_2',
    style: {
      backgroundColor: '#C300FF66',
    },
  },
  synonym_level_3: {
    value: 'synonym_level_3',
    style: {
      backgroundColor: '#DB65FF',
    },
  },
  synonym: {
    value: 'synonym',
    style: {
      backgroundColor: '#C300FF33',
    },
  },
  variety_level_0: {
    value: 'variety_level_0',
    style: {
      backgroundColor: '#C300FF33',
    },
  },
  variety_level_1: {
    value: 'variety_level_1',
    style: {
      backgroundColor: '#C300FF33',
    },
  },
  variety_level_2: {
    value: 'variety_level_2',
    style: {
      backgroundColor: '#C300FF66',
    },
  },
  variety_level_3: {
    value: 'variety_level_3',
    style: {
      backgroundColor: '#DB65FF',
    },
  },
  variety: {
    value: 'variety',
    style: {
      backgroundColor: '#C300FF33',
    },
  },
  already_found: {
    value: 'already_found',
    style: {
      backgroundColor: '#D3D3D3CC',
    },
  },
  mlSuggested: {
    value: 'mlSuggested',
    style: {
      backgroundColor: '#FFDB40',
    },
  },
  dietLabelLegend_exact: {
    value: 'dietLabelLegend_exact',
    style: {
      backgroundColor: '#434343',
      color: '#FFFFFF',
    },
  },
  dietLabelLegend_alreadyFound: {
    value: 'dietLabelLegend_alreadyFound',
    style: {
      backgroundColor: '#979797',
      color: '#FFFFFF',
    },
  },
  dietLabelLegend_exact_choice: {
    value: 'dietLabelLegend_exact_choice',
    style: {
      backgroundColor: '#044d02',
      color: '#FFFFFF',
    },
  },
  dietLabelLegend_alreadyFound_choice: {
    value: 'dietLabelLegend_alreadyFound_choice',
    style: {
      backgroundColor: '#979797',
      color: '#FFFFFF',
    },
  },
  allergenLabelLegend_exact: {
    value: 'allergenLabelLegend_exact',
    style: {
      backgroundColor: '#434343',
      color: '#FFFFFF',
    },
  },
  allergenLabelLegend_alreadyFound: {
    value: 'allergenLabelLegend_alreadyFound',
    style: {
      backgroundColor: '#979797',
      color: '#FFFFFF',
    },
  },
  allergenLabelLegend_exact_choice: {
    value: 'allergenLabelLegend_exact_choice',
    style: {
      backgroundColor: '#044d02',
      color: '#FFFFFF',
    },
  },
  allergenLabelLegend_alreadyFound_choice: {
    value: 'allergenLabelLegend_alreadyFound_choice',
    style: {
      backgroundColor: '#979797',
      color: '#FFFFFF',
    },
  },
  negativeSynonym: {
    value: 'negativeSynonym',
    style: {
      textDecoration: 'line-through',
    },
  },
  commonNegativeSynonym: {
    value: 'commonNegativeSynonym',
    style: {
      textDecoration: 'line-through',
    },
  },
  overrides: {
    value: 'overrides',
    style: {
      border: '1px solid black',
    },
  },
  middlePairingPhrase: {
    value: 'middlePairingPhrase',
    style: {
      border: '1px dashed black',
      borderRight: 'none',
      borderLeft: 'none',
    },
  },
  pairingPhraseStart: {
    value: 'pairingPhraseStart',
    style: {
      border: '1px dashed black',
      borderRight: 'none',
    },
  },
  pairingPhraseEnd: {
    value: 'pairingPhraseEnd',
    style: {
      border: '1px dashed black',
      borderLeft: 'none',
    },
  },
  pairingPhrase: {
    value: 'pairingPhrase',
    style: {
      border: '1px dashed black',
    },
  },
  middleReferencingWord: {
    value: 'middleReferencingWord',
    style: {
      border: '1px dashed black',
    },
  },
  referencingWordStart: {
    value: 'referencingWordStart',
    style: {
      border: '1px dashed black',
      borderRight: 'none',
    },
  },
  referencingWordEnd: {
    value: 'referencingWordEnd',
    style: {
      border: '1px dashed black',
      borderLeft: 'none',
    },
  },
  referencingWord: {
    value: 'referencingWord',
    style: {
      border: '1px dashed black',
    },
  },
  replacement: {
    value: 'replacement',
    style: {
      backgroundColor: '#D6A2BC',
    },
  },
  alternativeType: {
    value: 'alternativeType',
    style: { backgroundColor: '#ADA9FC' },
  },
  labelOccurrence: {
    value: 'labelOccurrence',
    style: { backgroundColor: '#EAFF8F' },
  },
  discrepancyNotAccepted: {
    value: 'discrepancyNotAccepted',
    style: {
      textDecoration: 'line-through',
    },
  },
  curationDisabled: {
    value: 'curationDisabled',
    style: {
      textDecoration: 'line-through',
      color: 'rgba(0, 0, 0, 0.25)',
      backgroundColor: 'none',
    },
  },
}

export default AI_HIGHLIGHT_STYLES
